import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { MainNavbarComponent } from './core/components/main-navbar/main-navbar.component';
import { ChatWidgetComponent } from './features/chat-widget/chat-widget.component';
import { AuthService } from './core/services/auth.service';
import { CompanyPdfReportComponent } from './features/results/components/company-pdf-report/company-pdf-report.component';
import { ThemePdfReportComponent } from './features/results/components/theme-pdf-report/theme-pdf-report.component';
import { ReportJobsService } from './features/results/services/report-jobs.service';
import { HistoryDownloadTrayComponent } from './features/results/components/history-download-tray/history-download-tray.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MainNavbarComponent, CompanyPdfReportComponent, ThemePdfReportComponent, HistoryDownloadTrayComponent,ChatWidgetComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend';
  showChatWidget = false;
  private authSub?: Subscription;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.checkLogin();
    this.authSub = this.authService.authenticated.subscribe((auth) => {
      // Alpha-only for now — remove role check to enable for all users
      const roles = localStorage.getItem('roles') || '';
      this.showChatWidget = auth && roles.includes('alpha');
    });
  }

  ngOnDestroy() {
    this.authSub?.unsubscribe();
  }
  reportJobs = inject(ReportJobsService);
  trackByTabId = (_: number, t: { tabId: string }) => t.tabId;
}
